import CryptoJS from 'crypto-js';

export const parseJwt = (token)=> {
    const base64Url = token.split('.')[1];
    const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
    const jsonPayload = decodeURIComponent(atob(base64).split('').map(function(c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(''));

    return JSON.parse(jsonPayload);
}

 
export const encrypt = (text, key) => {
    const hash = CryptoJS.SHA256(key);
 
    const ciphertext = CryptoJS.AES.encrypt(text, hash, {
        mode: CryptoJS.mode.ECB,
    }).toString();
 
    const wordArray = CryptoJS.enc.Base64.parse(ciphertext);
 
    return CryptoJS.enc.Hex.stringify(wordArray);
 
};
 
export const decrypt = (text, key) => {
    const hash = CryptoJS.SHA256(key);
    const wordArray = CryptoJS.enc.Hex.parse(text);
    const toDecrypt = CryptoJS.enc.Base64.stringify(wordArray);
 
    const bytes = CryptoJS.AES.decrypt(toDecrypt, hash, {
        mode: CryptoJS.mode.ECB,
    });
 
    return bytes.toString(CryptoJS.enc.Utf8);
};

export const encode = (payload) =>
{
    return btoa(JSON.stringify(payload)); 
}

export const decode = (payload) =>
{
    return JSON.parse(atob(payload)); 
}